import React, { ReactNode } from 'react';
import { BasePanelProps, FormSections, ProductConfigFactValue } from '../../../types';

type CustomSections = BasePanelProps['customSections'];
type ConfigurationByAccount = BasePanelProps['configurationByAccount'];

export type DefaultSectionsConfig = Partial<Record<FormSections, ReactNode>>;

interface Props {
  section: FormSections;
  defaultSections: DefaultSectionsConfig;
  customSections?: CustomSections;
  configurationByAccount?: ConfigurationByAccount;
  onChangeProductsConfig: (configField: string, nextValue: ProductConfigFactValue) => void;
}

export const DeskingFormSection = ({
  section,
  defaultSections,
  customSections,
  configurationByAccount,
  onChangeProductsConfig,
}: Props) => {
  const config = customSections?.[section];

  if (config?.isHidden) return null;

  return <>{config?.render?.(onChangeProductsConfig, configurationByAccount) ?? defaultSections[section] ?? null}</>;
};
